import { List, Text } from 'braid-design-system';
import React, { type ComponentProps } from 'react';

interface Props {
  items: string[];
  size?: ComponentProps<typeof List>['size'];
}

export const KeySellingPointList = ({ items, size = 'standard' }: Props) => (
  <List type="bullet" space="small" size={size}>
    {items
      .filter((item) => item.length > 0)
      .map((ksp: string, index) => (
        <Text key={`ksp-${index + 1}`}>{ksp}</Text>
      ))}
  </List>
);
